import { ClassNames } from '@emotion/react';
import { IconInfoOutlined, IconHelpOutlined } from '@hubble/icons/web';
import RCTooltip from 'rc-tooltip';
import React__default from 'react';
import { HubbleProvider } from '../ThemeProvider/index.js';
import { OFFSETS, CLS_PREFIX } from './constants.js';
import { getStyles, TooltipChildrenContainer, IconContainer, TooltipText } from './styles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const Tooltip = props => {
  const {
    ['data-testid']: testID,
    align,
    children,
    containerTestId,
    defaultVisible,
    disabled,
    overlayInnerStyle,
    maxWidth = 250,
    width,
    mouseEnterDelay = 0.2,
    onVisibleChange,
    overlay,
    overlayClassName,
    placement = 'top',
    textAlign = 'start',
    trigger,
    visible,
    zIndex = 10000
  } = props;
  if (disabled) return jsx(React__default.Fragment, {
    children: children
  });
  const visibilityProps = {};
  if (typeof visible === 'boolean') {
    visibilityProps.visible = visible;
  }
  if (typeof defaultVisible === 'boolean') {
    visibilityProps.defaultVisible = defaultVisible;
  }
  return jsx(ClassNames, {
    children: ({
      css,
      cx,
      theme
    }) => jsx(RCTooltip, {
      align: {
        ...align,
        offset: (align === null || align === void 0 ? void 0 : align.offset) || OFFSETS[placement]
      },
      destroyTooltipOnHide: {
        keepParent: false
      },
      mouseEnterDelay: mouseEnterDelay,
      onVisibleChange: onVisibleChange,
      overlay: typeof overlay === 'string' ? overlay : jsx(HubbleProvider, {
        scheme: "dark",
        children: overlay
      }),
      overlayClassName: cx(overlayClassName, [css(getStyles({
        theme,
        textAlign,
        maxWidth,
        width
      }), {
        label: CLS_PREFIX
      })]),
      overlayInnerStyle: overlayInnerStyle,
      placement: placement,
      prefixCls: CLS_PREFIX,
      showArrow: false,
      trigger: trigger,
      zIndex: zIndex,
      ...visibilityProps,
      children: jsx(TooltipChildrenContainer, {
        "data-testid": containerTestId || testID,
        children: children
      })
    })
  });
};
const TooltipWithIcon = ({
  children,
  disabled,
  icon,
  inline,
  ...rest
}) => {
  if (disabled) return jsx(React__default.Fragment, {
    children: children
  });
  return jsxs(IconContainer, {
    inline: inline,
    children: [children && jsx(TooltipText, {
      inline: inline,
      children: children
    }), jsx(Tooltip, {
      ...rest,
      children: icon
    })]
  });
};
Tooltip.Info = props => jsx(TooltipWithIcon, {
  ...props,
  icon: jsx(IconInfoOutlined, {
    size: "xs"
  })
});
Tooltip.Question = props => jsx(TooltipWithIcon, {
  ...props,
  icon: jsx(IconHelpOutlined, {
    size: "xs"
  })
});

export { Tooltip };
